import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import dayjs from 'dayjs';
import { getCommonRoutePath, getCurrentColor, onUserImgError } from '../../../../helpers/Helpers';
import userDefaultAvatar from '../../../../assets/img/placeholder-user.png';

import duration from 'dayjs/plugin/duration';
import { Image } from 'antd';
dayjs.extend(duration);

class ParticipantsInfoPopup extends PureComponent {
    renderParticipantsView = (ambassadors) => {
        let index = [];
        const membersView = ambassadors.map((member, i) => {
            index += 1;
            let subject = '';
            let courses = '';
            let jobTitle = '';
            if (member.user_tags) {
                subject =
                    member.user_tags.subject && member.user_tags.subject[0] ? member.user_tags.subject[0].name : '';
                courses =
                    member.user_tags.courses_types && member.user_tags.courses_types[0]
                        ? member.user_tags.courses_types[0].name
                        : '';
                jobTitle =
                    member.user_tags.job_title && member.user_tags.job_title[0]
                        ? member.user_tags.job_title[0].name
                        : '';
            }
            const currentUserColor = getCurrentColor(member, index);
            const online = member.last_online
                ? dayjs.duration(dayjs().diff(dayjs(member.last_online.updated_at))).asMinutes()
                : 10;

            return (
                <div key={member.id} className="member-item">
                    <NavLink
                        end
                        to={getCommonRoutePath() + '/chat-to-us/' + member.id}
                        className="chat-random-img-block sa-random-img-block"
                    >
                        {member.avatar ? (
                            <>
                                <Image
                                    className="chat-name-img"
                                    src={
                                        member.avatar
                                            ? member.avatar.sizes['70x70'] || member.avatar.original
                                            : userDefaultAvatar
                                    }
                                    onError={onUserImgError}
                                    alt={member.name ? member.name.slice(0, 1).toUpperCase() : 'D'}
                                />
                            </>
                        ) : (
                            <div className="chat-name-img" style={{ backgroundColor: currentUserColor }}>
                                <span>{member.name ? member.name.slice(0, 1).toUpperCase() : 'D'}</span>
                            </div>
                        )}
                    </NavLink>
                    <NavLink end to={getCommonRoutePath() + '/chat-to-us/' + member.id}>
                        <div className="member-block-info">
                            <p className="member-block-info-top">
                                <span className="member-name">{member.name}</span>
                            </p>
                            <span className="member-text">
                                {subject} {courses} {jobTitle}
                            </span>
                            <span className={online < 5 ? 'mod-online' : 'mod-offline'}></span>
                        </div>
                    </NavLink>
                </div>
            );
        });
        return membersView;
    };

    render() {
        const { ambassadors } = this.props.patricipants;
        return (
            <>
                <div className="">
                    <div className="participants-counter">Participants ({ambassadors.length})</div>
                    <div className="chat-members-body-block">{this.renderParticipantsView(ambassadors)}</div>
                </div>
            </>
        );
    }
}

export default connect((state) => {
    return {
        currentChat: state.currentChat,
    };
})(ParticipantsInfoPopup);
